import { useSubscription } from 'commons/useSubscription'

const BRAINTREE_CASH = 'cash'
const hasPlanAddManual = (subscription) => {
  return subscription.braintreeId === BRAINTREE_CASH
}

export const usePlanAddManual = () => {
  const subscription = useSubscription()
  const isPlanAddManual = hasPlanAddManual(subscription)

  return [isPlanAddManual]
}
